import ManagerRepository from '../ports/ManagerRepository';
import { ManagerCapabilities } from '../../domain/ManagerCapabilities';

const getCurrentManagerCapabilities =
  ({ managerRepository }: { managerRepository: ManagerRepository }) =>
  (): ManagerCapabilities => {
    const manager = managerRepository.getCurrentManager();
    return ManagerCapabilities.fromManager(manager);
  };

export default getCurrentManagerCapabilities;
